// extracted by mini-css-extract-plugin
module.exports = {"textIconF":"TextIconF_textIconF__tYFMJ"};